module.exports = __webpack_public_path__ + "assets/img/tit5.1be791b8.png";